import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui';

const IDLE_MS = 5 * 60 * 1000;
const CHECK_MS = 30 * 1000;

const IdleLogoutReminder = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const lastActivityRef = useRef(Date.now());
  const lastReminderRef = useRef(0);

  useEffect(() => {
    if (!user) {
      setIsVisible(false);
      return undefined;
    }

    const markActive = () => {
      lastActivityRef.current = Date.now();
      lastReminderRef.current = 0;
      if (isVisible) {
        setIsVisible(false);
      }
    };

    const events = ['mousemove', 'keydown', 'scroll', 'touchstart'];
    events.forEach((eventName) => window.addEventListener(eventName, markActive, { passive: true }));

    const interval = window.setInterval(() => {
      const now = Date.now();
      const idleTime = now - lastActivityRef.current;

      if (idleTime >= IDLE_MS) {
        const timeSinceReminder = now - lastReminderRef.current;
        if (lastReminderRef.current === 0 || timeSinceReminder >= IDLE_MS) {
          lastReminderRef.current = now;
          setIsVisible(true);
        }
      }
    }, CHECK_MS);

    return () => {
      events.forEach((eventName) => window.removeEventListener(eventName, markActive));
      window.clearInterval(interval);
    };
  }, [user, isVisible]);

  if (!user || !isVisible) {
    return null;
  }

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 w-full max-w-sm rounded-soft-lg border border-amber-200 bg-amber-50 p-4 shadow-soft-lg">
      <p className="text-sm font-semibold text-amber-900">Security reminder</p>
      <p className="mt-1 text-sm text-amber-800">
        You have been inactive. Please log out when you are done using Momentum.
      </p>
      <div className="mt-3 flex gap-2">
        <Button variant="ghost" size="sm" onClick={() => setIsVisible(false)}>
          Dismiss
        </Button>
        <Button variant="primary" size="sm" onClick={handleLogout}>
          Log out
        </Button>
      </div>
    </div>
  );
};

export default IdleLogoutReminder;
